export default function (controller) {
  const bootstrap = window.bootstrap;
  if (!bootstrap) return;

  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el));
}
